// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ExternalReviewAuthor () {
        return ExternalReviewAuthor;
    },
    get GoalDiscussionAnswerModel () {
        return GoalDiscussionAnswerModel;
    },
    get RatingScaleOptionModel () {
        return RatingScaleOptionModel;
    },
    get ReviewAuthorParticipant () {
        return ReviewAuthorParticipant;
    },
    get ReviewModel () {
        return ReviewModel;
    },
    get ReviewParticipant () {
        return ReviewParticipant;
    },
    get ReviewQuestionCalculatorAggregationModel () {
        return ReviewQuestionCalculatorAggregationModel;
    },
    get ReviewQuestionModel () {
        return ReviewQuestionModel;
    },
    get ReviewQuestionTypeModel () {
        return ReviewQuestionTypeModel;
    },
    get ReviewReportAnswerModel () {
        return ReviewReportAnswerModel;
    },
    get ReviewReportAwaitingApprovalModel () {
        return ReviewReportAwaitingApprovalModel;
    },
    get ReviewReportModel () {
        return ReviewReportModel;
    },
    get ReviewReportSnapshotModel () {
        return ReviewReportSnapshotModel;
    },
    get SingleRelativeParticipant () {
        return SingleRelativeParticipant;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const SingleRelativeParticipant = _zod.z.enum([
    "self",
    "manager",
    "manager-manager",
    "other"
]);
const ReviewParticipant = _zod.z.union([
    _zod.z.instanceof(_bson.ObjectId),
    SingleRelativeParticipant,
    _zod.z.literal("contributors")
]);
const ReviewAuthorParticipant = _zod.z.union([
    ReviewParticipant,
    _zod.z.literal("direct-reports")
]);
const ExternalReviewAuthor = _zod.z.object({
    name: _zod.z.string(),
    email: _zod.z.string(),
    "email-body": _zod.z.string()
});
const GoalDiscussionAnswerModel = _zod.z.object({
    goal_id: _zod.z.instanceof(_bson.ObjectId),
    message: _zod.z.string().optional(),
    scale_value: _zod.z.number().optional(),
    selected_option_index: _zod.z.number().optional(),
    score: _zod.z.number().optional(),
    weight: _zod.z.number().optional()
});
const ReviewReportAnswerModel = _zod.z.union([
    _zod.z.array(GoalDiscussionAnswerModel),
    _zod.z.number(),
    _zod.z.string(),
    _zod.z.array(_zod.z.string())
]);
const ReviewReportModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string().optional(),
    company: _zod.z.instanceof(_bson.ObjectId),
    subject: _zod.z.instanceof(_bson.ObjectId),
    review_parent: _zod.z.instanceof(_bson.ObjectId),
    form_id: _zod.z.instanceof(_bson.ObjectId),
    form_assignment_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    authors_due_date: _zod.z.date().nullish(),
    signers_due_date: _zod.z.date().nullish(),
    author: _zod.z.instanceof(_bson.ObjectId).nullable(),
    signer: _zod.z.instanceof(_bson.ObjectId).nullable(),
    authors: _zod.z.array(_zod.z.union([
        _zod.z.instanceof(_bson.ObjectId),
        _zod.z.null()
    ])),
    signers: _zod.z.array(_zod.z.union([
        _zod.z.instanceof(_bson.ObjectId),
        _zod.z.null()
    ])),
    participants: _zod.z.array(_zod.z.union([
        _zod.z.instanceof(_bson.ObjectId),
        _zod.z.null()
    ])).optional(),
    visible: _zod.z.boolean(),
    redacted: _zod.z.boolean(),
    start_date: _zod.z.date(),
    easy_add_data: _zod.z.object({
        created_by: _zod.z.instanceof(_bson.ObjectId),
        easy_add_config: _zod.z.instanceof(_bson.ObjectId),
        requiresApproval: _zod.z.string().nullable(),
        allow_comments: _zod.z.boolean()
    }).optional(),
    answers: _zod.z.array(ReviewReportAnswerModel),
    author_turn: _zod.z.number(),
    signer_turn: _zod.z.number(),
    participant_turn: _zod.z.number().optional(),
    form_comment: _zod.z.string().max(500).optional(),
    closed: _zod.z.boolean().optional(),
    completed: _zod.z.boolean().optional(),
    last_author_change: _zod.z.date().optional(),
    last_signer_change: _zod.z.date().optional(),
    submit: _zod.z.boolean().optional(),
    submit_date: _zod.z.date().optional(),
    submit_dates: _zod.z.record(_zod.z.number(), _zod.z.date()).optional(),
    complete_date: _zod.z.date().optional(),
    external: _zod.z.boolean().optional(),
    external_author: _zod.z.string().optional(),
    external_author_email: _zod.z.string().optional(),
    external_author_invitation: _zod.z.string().optional(),
    invite_sent: _zod.z.boolean().optional(),
    token: _zod.z.string().optional(),
    signed: _zod.z.boolean().optional(),
    sign_off_dates: _zod.z.record(_zod.z.number(), _zod.z.date()).optional(),
    overdue: _zod.z.boolean().optional(),
    sign_off_comments: _zod.z.record(_zod.z.number(), _zod.z.string()).optional(),
    deleted: _zod.z.boolean().optional(),
    deleted_at: _zod.z.date().nullish(),
    last_invite: _zod.z.date().optional(),
    approval: _zod.z.object({
        approved_by: _zod.z.instanceof(_bson.ObjectId).optional(),
        approved_at: _zod.z.date().optional(),
        approval_status: _zod.z.string().optional(),
        pending_review_report: _zod.z.instanceof(_bson.ObjectId).optional()
    }).optional()
});
const ReviewModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    subject: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    start_date: _zod.z.date(),
    creator: _zod.z.instanceof(_bson.ObjectId).nullish(),
    company: _zod.z.instanceof(_bson.ObjectId),
    deleted: _zod.z.boolean().optional(),
    complete_date: _zod.z.date().nullish(),
    workflow_id: _zod.z.instanceof(_bson.ObjectId).nullish(),
    admins_only: _zod.z.boolean().optional(),
    closed: _zod.z.boolean().optional(),
    unassigned_reports: _zod.z.number(),
    // Note, when a review report is deleted it is not always pulled from these array
    reports: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    participants: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    completed: _zod.z.boolean(),
    deleted_metadata: _zod.z.object({
        review_cycle_id: _zod.z.instanceof(_bson.ObjectId).nullable(),
        deleted_at: _zod.z.date().nullable()
    }).optional()
});
const ReviewQuestionTypeModel = _zod.z.enum([
    "text",
    "multiline",
    "multiple-select",
    "date",
    "stars",
    "goal-creation",
    "goal-discussion",
    "calculator",
    "rating-scale",
    "multiple-choice",
    "instructions",
    "numeric"
]);
const ReviewQuestionCalculatorAggregationModel = _zod.z.enum([
    "sum",
    "average"
]);
const RatingScaleOptionModel = _zod.z.object({
    value: _zod.z.union([
        _zod.z.number(),
        _zod.z.literal("")
    ]),
    name: _zod.z.string().min(1, {
        message: "This is a required field"
    }).refine((val)=>val.trim() !== "", {
        message: "This is a required field"
    }),
    description: _zod.z.string().optional()
});
const ReviewQuestionModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    type: ReviewQuestionTypeModel,
    is_hidden: _zod.z.boolean().optional(),
    question: _zod.z.string().max(3000, {
        message: "Question has maximum length of 3000 characters"
    }).default(""),
    /**
	 * For rating scale questions, this is an array of choices.
	 * For multiple choice questions, this is an array of strings.
	 */ choices: _zod.z.union([
        _zod.z.array(_zod.z.string().min(1, {
            message: "Choice cannot be empty"
        })),
        _zod.z.array(RatingScaleOptionModel)
    ]).optional(),
    aggregation: ReviewQuestionCalculatorAggregationModel.optional(),
    questions: _zod.z.array(_zod.z.object({
        id: _zod.z.instanceof(_bson.ObjectId),
        weight: _zod.z.number()
    })).optional(),
    subtext: _zod.z.string().max(12000, {
        message: "Subtitle has maximum length of 12,000 characters"
    }).optional(),
    add_scaling: _zod.z.array(RatingScaleOptionModel).optional(),
    score_weights: _zod.z.boolean().optional(),
    max: _zod.z.number().optional(),
    min: _zod.z.number().optional(),
    decimals: _zod.z.boolean().optional(),
    add_scoring: _zod.z.boolean().optional(),
    "multi-select-minimum": _zod.z.number().optional(),
    "multi-select-maximum": _zod.z.number().optional(),
    scoring_max: _zod.z.number().optional(),
    scoring_min: _zod.z.number().optional(),
    is_required: _zod.z.boolean().optional()
});
const ReviewReportAwaitingApprovalModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    approval_status: _zod.z.enum([
        "pending",
        "declined"
    ]),
    author: _zod.z.instanceof(_bson.ObjectId),
    authors: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    authors_due_date: _zod.z.date(),
    company: _zod.z.instanceof(_bson.ObjectId),
    deleted: _zod.z.boolean().optional(),
    easy_add_data: _zod.z.object({
        allow_comments: _zod.z.boolean().optional(),
        created_by: _zod.z.instanceof(_bson.ObjectId),
        easy_add_config: _zod.z.instanceof(_bson.ObjectId),
        requiresApproval: _zod.z.string().optional()
    }),
    form_comment: _zod.z.string().max(500).optional(),
    form_id: _zod.z.instanceof(_bson.ObjectId),
    redacted: _zod.z.boolean(),
    review_parent: _zod.z.instanceof(_bson.ObjectId),
    signer: _zod.z.instanceof(_bson.ObjectId).optional(),
    signers: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    signers_due_date: _zod.z.date(),
    start_date: _zod.z.date(),
    subject: _zod.z.instanceof(_bson.ObjectId),
    visible: _zod.z.boolean()
});
const ReviewReportSnapshotModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    action: _zod.z.enum([
        "submit",
        "dump",
        "save"
    ]),
    actor: _zod.z.instanceof(_bson.ObjectId),
    actor_type: _zod.z.enum([
        "author",
        "signer"
    ]),
    answers: _zod.z.array(_zod.z.union([
        _zod.z.string(),
        _zod.z.number(),
        _zod.z.array(_zod.z.string()),
        _zod.z.object({})
    ])),
    company: _zod.z.instanceof(_bson.ObjectId),
    created_at: _zod.z.date(),
    review: _zod.z.instanceof(_bson.ObjectId),
    review_report: _zod.z.instanceof(_bson.ObjectId),
    session: _zod.z.instanceof(_bson.ObjectId)
});
